module.exports = {

	"fr": "Français",
	"en": "English",
	"de": "Deutsch",
	"fr-dz": "Français",
	"es-ar": "Español",
	"en-au": "English",
	"nl-be": "Nederlands",
	"fr-be": "Français",
	"es-bo": "Español",
	"bs-ba": "Bosanski",
	"pt-br": "Português",
	"en-ca": "English",
	"fr-ca": "Français",
	"cs-cz": "Český",
	"es-cl": "Español",
	"es-co": "Español",
	"es-cr": "Español",
	"sr-me": "Srpski",
	"en-cy": "English",
	"da-dk": "Dansk",
	"de-de": "Deutsch",
	"es-ec": "Español",
	"et-ee": "Eesti",
	"en-eg": "English",
	"es-sv": "Español",
	"es-es": "Español",
	"fr-fr": "Français",
	"es-gt": "Español",
	"en-gulf": "English",
	"es-hn": "Español",
	"en-hk": "Español",
	"hr-hr": "Hrvatski",
	"en-in": "English",
	"id-id": "Bahasa Indonesia",
	"en-ie": "English",
	"is-is": "Íslenska",
	"it-it": "Italiano",
	"en-jo": "English",
	"lv-lv": "Latviešu",
	"en-lb": "English",
	"lt-lt": "Lietuvių",
	"hu-hu": "Magyarország",
	"en-my": "English",
	"en-mt": "English",
	"es-mx": "Español",
	"fr-ma": "Français",
	"nl-nl": "Nederlands",
	"en-nz": "English",
	"es-ni": "Español",
	"en-ng": "English",
	"nb-no": "Norsk",
	"de-at": "Deutsch",
	"en-pk": "English",
	"es-pa": "Español",
	"es-py": "Español",
	"es-pe": "Español",
	"en-ph": "English",
	"pl-pl": "Polski",
	"pt-pt": "Português",
	"es-pr": "Español",
	"es-do": "Español",
	"ro-md": "Română",
	"ro-ro": "Română",
	"en-sa": "English",
	"de-ch": "Deutsch",
	"en-sg": "English",
	"sl-si": "Slovenščina",
	"sk-sk": "Slovenčina",
	"en-za": "English",
	"sr-rs": "Srpski",
	"en-lk": "English",
	"fr-ch": "Français",
	"fi-fi": "Suomi",
	"sv-se": "Svenska",
	"fr-tn": "Français",
	"tr-tr": "Türkçe",
	"en-gb": "English",
	"en-us": "English",
	"es-uy": "Español",
	"es-ve": "Español",
	"vi-vn": "Tiếng Việt",
	"el-gr": "Ελληνικά",
	"ru-by": "Русский",
	"bg-bg": "Български",
	"kk-kz": "Қазақ",
	"ru-kz": "Русский",
	"ru-ru": "Русский",
	"uk-ua": "Українська",
	"he-il": "עִבְרִית",
	"ar-iq": "العراق",
	"ar-sa": "المملكة",
	"ar-ly": "ليبيا",
	"ar-eg": "مصر",
	"ar-gulf": "دول",
	"th-th": "ไทย",
	"ko-kr": "한국어",
	"zh-cn": "中国語",
	"zh-tw": "台灣語",
	"ja-jp": "日本語",
	"zh-hk": "中国語",
	"xx-xx": "Keys"
};